export default "__VITE_ASSET__CuYIytd$__"